import {apiHttpClient} from "@/http/httpClient";
import type {Vehicle} from "@/models/vehicle/vehicle";
import type {IOptionModel} from "@/models/option";
import { Country } from '@/constants/country';
import type { PaginationItems } from "@/models/pagination";
import type { VehicleListModel, VehicleListRequest } from "@/models/vehicle/vehicle-list";
import type { AssignmentVehicleInformation } from "@/models/assignment/edit/vehicle-information";
import type { VehicleHistoryModel } from "@/models/vehicle/vehicle-history";

const ENDPOINT_LIST = 'Vehicle/List';
const ENDPOINT_GET_BY_LICENSE_PLATE = 'Vehicle/GetByLicensePlate';
const ENDPOINT_GET_BY_CHASSIS_NUMBER = 'Vehicle/GetByChassisNumber';
const ENDPOINT_GET_BRANDS = 'Vehicle/GetBrands';
const ENDPOINT_GET_MODELS = 'Vehicle/GetModels';
const ENDPOINT_CREATE = 'Vehicle/Create';
const ENDPOINT_UPDATE_VEHICLE_INFORMATION = 'Vehicle/UpdateVehicleInformation';
const ENDPOINT_GET_HISTORY = 'Vehicle/GetHistory';

export const listVehicles = (request: VehicleListRequest) => {
    return apiHttpClient().post<PaginationItems<VehicleListModel>>(ENDPOINT_LIST, request)
        .then(response => {
            return response;
        })
        .catch(error => {
            return error;
        })
}

export const getByLicensePlate = (country: Country, licensePlate: string) => {
    return apiHttpClient().get<Vehicle>(ENDPOINT_GET_BY_LICENSE_PLATE, {
            params: {
                country: country,
                licensePlate: licensePlate
            }
        })
        .then(response => {
            return response;
        })
        .catch(error => {
            return error;
        })
}

export const getByChassisNumber = (chassisNumber: string) => {
    return apiHttpClient().get<Vehicle | null>(ENDPOINT_GET_BY_CHASSIS_NUMBER, {
            params: {
                chassisNumber: chassisNumber
            }
        })
        .then(response => {
            return response;
        })
        .catch(error => {
            return error;
        })
}

export const getBrands = () => {
    return apiHttpClient().get<IOptionModel<string>[]>(ENDPOINT_GET_BRANDS)
        .then(response => {
            return response;
        })
        .catch(error => {
            return error;
        })
}

export const getModels = (brand: string) => {
    return apiHttpClient().get<IOptionModel<string>[]>(ENDPOINT_GET_MODELS, {
            params: {
                brand: brand,
            }
        })
        .then(response => {
            return response;
        })
        .catch(error => {
            return error;
        })
}

export const createVehicle = (vehicle: Vehicle) => {
    return apiHttpClient().post<boolean>(ENDPOINT_CREATE, vehicle)
        .then(response => {
            return response;
        })
        .catch(error => {
            return error;
        })
}

export const updateVehicleInformation = async (vehicleId: number, vehicleInformation: AssignmentVehicleInformation) => {
    return await apiHttpClient().post(ENDPOINT_UPDATE_VEHICLE_INFORMATION, {
        vehicleId: vehicleId,
        ...vehicleInformation
    })
        .then(response => {
            return response;
        })
        .catch(error => {
            return error;
        })
}

export const getVehicleHistory = async (vehicleId: number) => {
    return await apiHttpClient().get<VehicleHistoryModel[]>(ENDPOINT_GET_HISTORY, { params: { vehicleId } })
        .then(response => response)
        .catch(error => error);
}
